// Manda cartões de mesa para a impressora do caixa (fila de impressão do
// sistema, igual aos cupons) e avisa o resultado com palavras de lojista.
import { toast } from "sonner";

import { imprimirCartoes } from "./api";

const SEM_COMPUTADOR =
  "Nenhum computador com o Núcleo Desktop está ligado à impressora agora. " +
  "Abra o Núcleo Desktop no computador do caixa e tente de novo.";

function motivoLegivel(motivo) {
  if (!motivo || /conectores offline|pending/i.test(motivo)) return SEM_COMPUTADOR;
  return motivo;
}

function mensagemDeErro(e) {
  const detalhe = e?.response?.data?.detail;
  return typeof detalhe === "string" ? detalhe : "Não consegui mandar para a impressora.";
}

/** `mesaIds` vazio = todas as mesas. */
export const imprimirNaTermica = (mesaIds) => mandarParaImpressora(() => imprimirCartoes(mesaIds));

/** Chama a rota que põe os cartões na fila e avisa o resultado. Também usado
 *  pelos QR Codes dos Links de divulgação (26/10/2026). */
export async function mandarParaImpressora(chamada) {
  try {
    const { data } = await chamada();
    const { total = 0, enviados = 0, motivo, desktop_desatualizado: desatualizado } = data || {};
    if (enviados && enviados === total) {
      toast.success(total === 1
        ? "Cartão enviado para a impressora do caixa."
        : `${total} cartões enviados para a impressora do caixa.`);
    } else if (!enviados) {
      toast.error(motivoLegivel(motivo), { duration: 8000 });
    } else {
      toast.warning(`${enviados} de ${total} cartões foram para a impressora. ${motivoLegivel(motivo)}`,
        { duration: 8000 });
    }
    if (enviados && desatualizado) {
      toast.info(
        "Um computador está com o Núcleo Desktop antigo: o cartão sai sem o nome no meio do QR. " +
        "Feche e abra o Núcleo Desktop para ele se atualizar.",
        { duration: 10000 });
    }
  } catch (e) {
    toast.error(mensagemDeErro(e));
  }
}
